// extracted by mini-css-extract-plugin
export var productImage = "_i2-1";
export var viewLink = "_i2-2";
export var wishlistItem = "_i2-0";